import { useRef } from "react";
import { Html } from "@react-three/drei";
import infoIcon from "../../static/images/info.png";
import { Tooltip } from "@mantine/core";

function InfoTextSpot({
	infoSpot,
	selectObject,
	isPreviewComponent,
	setIsInfoTextSpotOpen,
}) {
	const mesh = useRef(null);
	const onClickHandler = () => {
		if (!isPreviewComponent) {
			setIsInfoTextSpotOpen(true);
		} else {
			selectObject(infoSpot, mesh.current);
		}
	};
	return (
		<mesh ref={mesh} position={infoSpot.position}>
			<Html center zIndexRange={[100, 10]}>
				<Tooltip
					label={!isPreviewComponent ? infoSpot.text : null}
					color={
						!isPreviewComponent ? "rgba(0,0,0,0.6)" : "Transparent"
					}
				>
					<img
						src={infoIcon}
						className="infoTextspot"
						alt="information text"
						width="35px"
						height="35px"
						onClick={(e) => {
							onClickHandler();
						}}
					/>
				</Tooltip>
			</Html>
		</mesh>
	);
}

export default InfoTextSpot;
